import { Modal, FileUploader, FilePreview, Tooltip } from 'components/common';
import { ModalContext, HomeContext, UploadFileContext, AuthContext, ShipmentInfoContext, DocumentsContext } from 'contexts';
import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import {
    FILE_SUB_TYPE_SHIPMENT_DETAIL_DOCS,
    FILE_TYPE_BR_CMT_DOCS,
    GET_FILE,
    PDF_FILE_EXTENSION,
    MAX_FILE_SHIPMENT_DETAIL_DOCS,
} from 'actions';
import {
    Button,
    Comment
} from 'components';
import { getBase64DataFile, convertDate } from 'utils';
import moment from 'moment';
import avatar from 'assets/images/avatar.png';

export const PreviewDocument = ({ open = false, onCancel }) => {
    const { previewDocument } = useContext(ModalContext);
    const { fileId, idDocumentSignature, addNewDocument, setLoading, setRefreshDocumentSignature, refreshDocumentSignature, docType, setFileId } = useContext(HomeContext);
    const { doGetFileData } = useContext(UploadFileContext);
    const { doUploadFile } = useContext(UploadFileContext);
    const [arrayFiles, setArrayFiles] = useState([]);
    const [filesSelected, setFilesSelected] = useState([]);
    const { loggedInUser } = useContext(AuthContext);
    const { doUpdateDocumentVersion } = useContext(ShipmentInfoContext)
    const [fileData, setFileData] = useState(null);
    const { userInfo } = useContext(AuthContext);
    const { doCommentPreviewDocument } = useContext(DocumentsContext);
    const [files, setFiles] = useState([]);
    const { documentVersions, doGetDocumentSignatureDetailVersion, listComment } = useContext(DocumentsContext);
    /*eslint-disable */
    useEffect(() => {
        if (previewDocument && fileId && idDocumentSignature && open) {
            setFileData(null);
            doGetFileData(fileId, data => setFileData(data));
        }
    }, [idDocumentSignature, fileId, previewDocument]);

    useEffect(() => {
        if(idDocumentSignature && open) doGetDocumentSignatureDetailVersion(idDocumentSignature);
    }, [idDocumentSignature])

    useEffect(() => {
        if (!addNewDocument) {
            setArrayFiles([]);
        }
    }, [addNewDocument]);

    useEffect(() => {
        const filesBase64 = async () => {
            if (arrayFiles.length > 0) {
                let filesNew = await Promise.all(Array.from(arrayFiles).map(async file => {
                    const data = await getBase64DataFile(file);
                    return {
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        data,
                    };
                }));
                setFilesSelected(filesNew);
            }
        }
        filesBase64();
    }, [arrayFiles])

    /*eslint-enable */

    const sendComments = async (data, callback) => {
        let tmpAttachments = [];
        let promises = [];
        for (let file of files) {
            promises.push(doUploadFile({
                fileName: file.name.split('.').slice(0, -1).join('.'),
                type: FILE_TYPE_BR_CMT_DOCS,
                subType: FILE_TYPE_BR_CMT_DOCS,
                fileExtension: file.name.split('.').pop(),
            }, file.data, loggedInUser));
        }
        tmpAttachments = await Promise.all(promises);
        tmpAttachments = tmpAttachments.map(item => {
            return {
                fileId: item.id,
                fileName: item.name,
                fileExtension: item.fileExtension
            };
        });
        setFiles([]);
        const { comments } = data;
        const payload = {
            content: comments.trim(),
            attachments: tmpAttachments,
        }
        doCommentPreviewDocument(idDocumentSignature, payload, () => {
            callback();
            doGetDocumentSignatureDetailVersion(idDocumentSignature);
        })
        setFiles([]);
    }

    const handleFilesUpload = async uploadFiles => {
        setFiles(oldFiles => [...oldFiles, ...uploadFiles]);
    }

    const handleCancelFilesUpload = () => {
        setFiles([]);
        setFilesSelected([]);
        setArrayFiles([]);
    }
    const handleFileRemove = file => {
        if (!file) return;
        setFilesSelected(oldFiles => [...oldFiles.filter(f => !(f.name === file.name && f.size === file.size))])
        setArrayFiles(oldFiles => [...oldFiles.filter(f => !(f.name === file.name && f.size === file.size))])
    }

    const triggerUploadToS3 = async file => {
        setLoading(true);
        const arr = file.name.split('.');
        const fileExtension = arr.pop();
        const fileName = arr.join('.');
        const { id, url } = await doUploadFile({
            type: docType.type,
            subType: docType.sub,
            fileExtension,
            fileName,
            ocrRequired: true
        }, await getBase64DataFile(file), loggedInUser);

        setLoading(false);
        return {
            ...file,
            id,
            url,
            type: file.type,
            subType: file.subType,
            fileExtension,
            fileName
        };
    }

    const handleSaveVersion = async () => {
        if (arrayFiles && arrayFiles.length) {
            // upload Files Trigger
            const uploadedFile = await triggerUploadToS3(arrayFiles[0]);
            if (uploadedFile) {
                await doUpdateDocumentVersion(idDocumentSignature, {
                    documentId: uploadedFile?.id
                });
                await doGetDocumentSignatureDetailVersion(idDocumentSignature, (data) => {
                    if(data){
                        setRefreshDocumentSignature(!refreshDocumentSignature);
                    }
                });
                doGetFileData(uploadedFile?.id, data => setFileData(data));
                setArrayFiles([]);
                setFilesSelected([]);
            }
        }
    }

    const hanldeOnCancel = () => {
        setFileId('');
        onCancel();
    }

    return (
        <Modal
            open={open}
            onCancel={hanldeOnCancel}
            isBackDropClickable={false}
            title="Preview document"
            className="preview-document-detail"
        >
        <div className="col-12 d-flex">
            <div className="col-8 preview-document-detail_file d-flex flex-column">
                <div className="">
                    <embed src={fileData?.base64Url} width="100%" height="800"></embed>
                </div>
                <div className="tr__version-history ">
                    <div className="d-flex version-history-list">
                         <h5 className="h5 mbx3 mtx1 f-medium">Version history</h5>
                            {
                                documentVersions && documentVersions?.length > 0 &&  documentVersions?.map(item => (
                                    <div className="d-flex version-history-item">
                                        <h1>{item.documentId}</h1>
                                        <Tooltip content={item.createdBy.email}>
                                            <h1>{item.createdBy.name}</h1>
                                        </Tooltip>
                                        <h1>{convertDate(item.date, ('DD MMM YYYY | hh:mm:ss A'))}</h1>
                                    </div>
                                ))
                            }
                    </div>
                </div>

            </div>
            <div className="col-4 d-flex flex-wrap">
                <div className="reference-tab">
                    <div className="title-comment">
                        <h3 className="h3 f-medium">Comments</h3>
                    </div>
                    <div className="list-comment">
                        <p>{listComment.length} comment{listComment.length > 1 ? 's' : ''}</p>
                    </div>
                    <div className="comment-section">
                    {listComment && listComment.length > 0 ? listComment.map((comment, commentIndex) => (
                        <div className="comments-item d-flex" key={commentIndex}>
                            <>
                                <div className="comments-item--avatar mrx2">
                                <img src={comment?.createdBy?.avatar ? GET_FILE + comment?.createdBy?.avatar : avatar} alt={comment?.createdBy?.name} />
                                </div>
                                <div className="comments-item--content mbx3">
                                    <div className="user">
                                        <h6 className="h6 f-medium mbx1">{comment.createdBy.name}</h6>
                                        <p className="f-medium">{moment(comment.createdDate).format('DD MMM YYYY | hh:mm A')}</p>
                                    </div>
                                    <div className="content-comment mtx2">
                                        <pre>{comment.content}</pre>
                                    </div>
                                    {comment.attachments && comment.attachments.length > 0 && (
                                    <div className="gallery mtx3">
                                        {comment.attachments.map((item, itemIndex) => (
                                            <FilePreview
                                                file={GET_FILE + item.fileId}
                                                fileExtension={item.fileName.split('.').pop()}
                                                fileName={item.fileName}
                                            />
                                        ))}
                                    </div>
                                )}
                                </div>
                            </>
                        </div>
                    )) : (
                        <p className="mbx3"></p>
                    )}
                    </div>
                    <Comment
                        className='comment-tab-br'
                        user={userInfo}
                        onSendComment={sendComments}
                        isHaveAttachment={true}
                        attachments={files}
                        handleAddAttachments={handleFilesUpload}
                        handleCancelAddAttachments={handleCancelFilesUpload}
                        handleRemoveAttachment={handleFileRemove}
                        uploadOnlyImage={true}
                    />
                </div>

                <div className="preview-document-detail--upload-file">
                    <div className="update-version-document">
                        <div className="d-flex justify-content-between mbx1">
                            <h5 className="h5 mbx3 mtx1 f-medium">Update version document</h5>
                            <Button
                                onClick={handleSaveVersion}
                            >Save version
                            </Button>
                        </div>
                        <FileUploader
                            handleRemove={handleFileRemove}
                            uploadedFiles={filesSelected}
                            limitNumberUploadFile={MAX_FILE_SHIPMENT_DETAIL_DOCS}
                            outputFormat='base64'
                            name="uploadDocuments"
                            mode="list"
                            limitSizePerFile={PDF_FILE_EXTENSION}
                            fileTypeApproved={['pdf']}
                            multiple={false}
                            uploadInner={true}
                            uploadFileType={'shipping-document'}
                            uploadFileSubType={FILE_SUB_TYPE_SHIPMENT_DETAIL_DOCS}
                            selectType={false}
                            uploadOnSelect={false}
                            setArrayFiles={setArrayFiles}
                        >
                        </FileUploader>
                    </div>
                </div>

                
            </div>
        </div>
        </Modal>
    )
}
